import React from 'react';
import './index.less';

function PayoutActions({ children }) {
	return (
		<div className='payout-table--body--actions'>
			{children}
		</div>
	);
}

export default PayoutActions;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-actions/index.js